import React from 'react';
import { Link } from 'react-router-dom';
import { NavbarBrand } from 'reactstrap';

export const Logo = () => {
  return (
    <div>
      <NavbarBrand style={{ padding: 0 }} tag={Link} to='/'>
        <p style={{ fontSize: 30, color: '#172b4d', marginTop: 40 }}>Olympic</p>
      </NavbarBrand>
    </div>
  );
};
